<template>
	<div class="policy">
		<innerBanner :banner="$t('policy.banner')" />
		<div class="policy-wrap wp2">
			<!-- <aside>
				<a href="javascript:;" :class="curMenu === index ? 'active' : ''"
					v-for="(item,index) in menu" :key="index">
					{{item.title}}
				</a>
			</aside>

			<div class="m-select" :class="showOption ? 'open' : ''">
				<div class="show" @click="showOption = !showOption">{{curText}} <i></i></div>
				<ul v-if="showOption">
					<template v-for="(item,index) in $t('policy.menu')">
						<li :key="index" v-if="curText !== item.title"
							@click="curText = item.title;showOption=false">
							{{item.title}}
						</li>
					</template>
				</ul>
			</div> -->

			<div class="content" v-html="$t('policy.content')">

			</div>
		</div>
	</div>
</template>

<script>
import innerBanner from "@/components/innerBanner";

export default {
	name: "policy",
	components: {
		innerBanner
	},
	data() {
		return {
			curMenu: 0,
			menu: [
				{
					title: 'Privacy Policy'
				},
				{
					title: 'Cookie Policy'
				}
			],
			curText: '',
			showOption: false
		};
	},
	mounted() {
		window.scrollTo(0, 0);
		this.curText = this.menu[0].title;
	}
}
</script>

<style  lang="scss">
[data-custom-class='body'],
[data-custom-class='body'] * {
	background: transparent !important;
}
[data-custom-class='title'],
[data-custom-class='title'] * {
	font-family: Arial !important;
	font-size: 26px !important;
	color: #000000 !important;
}
[data-custom-class='subtitle'],
[data-custom-class='subtitle'] * {
	font-family: Arial !important;
	color: #595959 !important;
	font-size: 14px !important;
}
[data-custom-class='heading_1'],
[data-custom-class='heading_1'] * {
	font-family: Arial !important;
	font-size: 19px !important;
	color: #000000 !important;
}
[data-custom-class='heading_2'],
[data-custom-class='heading_2'] * {
	font-family: Arial !important;
	font-size: 17px !important;
	color: #000000 !important;
}
[data-custom-class='body_text'],
[data-custom-class='body_text'] * {
	color: #595959 !important;
	font-size: 14px !important;
	font-family: Arial !important;
}
[data-custom-class='link'],
[data-custom-class='link'] * {
	color: #3030f1 !important;
	font-size: 14px !important;
	font-family: Arial !important;
	word-break: break-word !important;
}
//policy
.policy {
	.policy-wrap {
		display: flex;
		padding: 66px 0;
		aside {
			flex: 0 0 220px;
			a {
				display: block;
				padding: 16px 0;
				@extend .regular-16px;
			}
			a.active {
				font-weight: 600;
			}
			a + a {
				border-top: 1px solid #dddbcb;
			}
		}
		.content {
			flex: 1;
			margin-left: 80px;
			h3 {
				@extend .h3-24px;
				margin-bottom: 18px;
			}
			p {
				@extend .regular-14px;
				margin-bottom: 34px;
			}
		}
	}
	.m-select {
		display: none;
	}
}

@media only screen and (max-width: 1199px) {
	.policy .policy-wrap {
		padding: 66px 20px;
	}
}
@media only screen and (max-width: 767px) {
	.policy .policy-wrap {
		display: block;
		padding: 40px 20px;
	}
	.policy .policy-wrap .content {
		margin-left: 0;
	}
	.policy .policy-wrap .content h3 {
		font-size: 18px;
		line-height: 27px;
		margin-bottom: 10px;
	}
	.policy .policy-wrap aside {
		display: none;
	}
	.policy {
		.m-select {
			display: block;
			margin-bottom: 30px;
			position: relative;
			.show {
				height: 44px;
				background: #f7f4f3;
				border-radius: 10px;
				display: flex;
				align-items: center;
				justify-content: space-between;
				padding: 0 20px;
				font-size: 16px;
				line-height: 1.5;
				i {
					display: block;
					width: 14px;
					height: 9px;
					background: url('~@/assets/images/down.png') no-repeat center center /
						contain;
				}
			}
			ul {
				position: absolute;
				padding: 10px 20px;
				top: 100%;
				left: 0;
				width: 100%;
				z-index: 10;
				background: #f7f4f3;
				border-radius: 0 0 10px 10px;
				li {
					padding: 10px 0;
					border-top: 1px solid #dddbcb;
				}
			}
		}
		.m-select.open {
			.show {
				border-radius: 10px 10px 0 0;
				i {
					background-image: url(~@/assets/images/up.png);
				}
			}
		}
	}
}
</style>
